import { render, staticRenderFns } from "./LeftTextRadio2.vue?vue&type=template&id=24f3389e&scoped=true"
import script from "./LeftTextRadio2.vue?vue&type=script&lang=js"
export * from "./LeftTextRadio2.vue?vue&type=script&lang=js"
import style0 from "./LeftTextRadio2.vue?vue&type=style&index=0&id=24f3389e&prod&scoped=true&lang=scss"
import style1 from "./LeftTextRadio2.vue?vue&type=style&index=1&id=24f3389e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3389e",
  null
  
)

export default component.exports